import React from 'react';
import { OrangeButton } from 'components/Button';
import styled from 'styled-components';
import { Typography, Box } from '@material-ui/core';
import SpeedDial from '@material-ui/lab/SpeedDial';
import { SpeedDialAction } from '@material-ui/lab';
import breakpoints from 'utils/breakpoints';
export const StyledDiv = styled.div`
  bottom: 60px;
  right: 20px;
  position: fixed;
`;
export const StyledSpeedDial = styled(SpeedDial)`
  && {
    right: 16px;
    bottom: 16px;
    height: 20px;
    position: fixed;
    &.Muifab-root {
      height: 10px;
      width: 10px;
    }
    @media (max-width: ${breakpoints.xs}) {
      left: 16px;
    }
  }
`;

export const StyledSpeedDialAction = styled(SpeedDialAction)`
  &.MuiSpeedDialAction-fab {
    width: auto;
    height: auto;
    border-radius: 8px;
  }
`;

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    border-radius: 24px !important;
    height: 40px !important;
    width: 150px !important;
    padding: 4px 5px !important;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  }
`;
export const StyledImg = styled(({ reverse, ...othersProps }) => (
  <img {...othersProps} alt="help-icon" />
))`
  margin-left: ${(props) => (props.reverse ? '0px' : '-12px')};
  margin-right: ${(props) => (props.reverse ? '-15px' : '0px')};
  margin-top: 26px;
`;

export const StyledTitle = styled(Typography)`
  font-size: 13px !important;
  font-weight: bold !important;
  line-height: 16px !important;
`;

export const BoxContainer = styled(Box)`
  box-shadow: 0 5px 9px 0 rgba(0, 0, 0, 0.16);
  width: 180px;
  height: auto;
`;

export const StyledTag = styled.a`
  text-decoration: none;
`;
